module.exports = __webpack_public_path__ + "static/media/icon-file-default.9c1ccabf.svg";